/* eslint-disable max-len */
import React, { memo, Fragment } from 'react'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import { comparePropsFn } from 'root/src/shared/util/stateCompare'
import DareVideoCard from './DareVideoCard'
import ActionButtonSet from './ActionButtonSet'
import AdminButtonSet from './AdminButtonSet'
import Icons from './Icons'
import DareTitleDescription from './DareTitleDescription'
import DareDetailsNotDelivered from './DareDetailsNotDelivered'
import DareDetailsComponent from './DareDetails'

const DareDetailWrapper = memo(({
	auditFavorites, myFavorites,
	projectDescription, projectTitle, pledgeAmount, assignees, brandProduct, sponsor,
	gameImage, classes, isAuthenticated, canEditProjectDetails, updateProject,
	pledgers, timeLeft, projectDeliveries, goalAmount, projectShareUrl, projectUrl,
	projectAcceptanceStatus, canRejectActiveProject, canApproveProject, canRejectProject,
	displayModal, moduleId, games, isMobileRes, authenticateTwitch, setInput, redirectAndPrePopulate,
	isTwitchPanelDare, oauthAuthenticate, claimSponsoredProject, creatorData, isBrandUser, projectId,
	reportCtaClick, userData, apiRequest, isAdmin, isFeatured, landingShortUrl, isOneOfAssignees,
	campaignId, isSubmittable,
}) => {
	const DareDetailIconSet = () => (
		<Icons {...{
			/* eslint-disable object-property-newline */
			classes, projectDeliveries, projectShareUrl,
			isAuthenticated, auditFavorites, myFavorites,
		}}
		/>
	)

	const DareDetailsTitleAndDescription = () => {
		const dareTitle = !projectDeliveries && true
		const fontSize = projectDeliveries && true
		return (
			<DareTitleDescription {...{
				/* eslint-disable object-property-newline */
				classes, canEditProjectDetails, projectTitle, projectDescription, fontSize,
				dareTitle, updateProject, isMobileRes, DareDetailIconSet, projectUrl,
			}}
			/>
		)
	}

	const DareDetails = () => (
		<DareDetailsComponent {...{
			classes, projectDeliveries, DareDetailsTitleAndDescription,
			games, timeLeft, pledgers, pledgeAmount, goalAmount, brandProduct,
			creatorData, isTwitchPanelDare, sponsor, isMobileRes, landingShortUrl, isOneOfAssignees,
			campaignId,
		}}
		/>
	)

	const DareDetailButtonSet = () => (
		<Fragment>
			<ActionButtonSet {...{
				/* eslint-disable object-property-newline */
				classes, projectUrl, assignees, projectAcceptanceStatus, isTwitchPanelDare,
				isAuthenticated, displayModal, moduleId, authenticateTwitch, oauthAuthenticate,
				brandProduct, claimSponsoredProject, isBrandUser, projectDeliveries, setInput, timeLeft,
				redirectAndPrePopulate, projectId, reportCtaClick, userData, apiRequest, isAdmin, isFeatured,
				landingShortUrl, isSubmittable,
			}}
			/>
			{
				(canApproveProject || canRejectProject || canRejectActiveProject)
				&& (
					<AdminButtonSet {...{
						canApproveProject, canRejectProject, canRejectActiveProject, classes, projectUrl,
					}}
					/>
				)
			}
		</Fragment>
	)

	return (
		<section className={ternary(!projectDeliveries, classes.dareDetailsRoot, classes.completedDareDetailsRoot)}>
			{
				ternary(projectDeliveries,
					<DareVideoCard {...{
						classes, isMobileRes, DareDetails, projectDeliveries, DareDetailButtonSet, DareDetailIconSet,
					}}
					/>,
					<DareDetailsNotDelivered {...{
						classes, gameImage, isMobileRes, DareDetails, DareDetailIconSet, DareDetailButtonSet, sponsor, campaignId,
					}}
					/>)
			}
		</section>
	)
})

export default memo(DareDetailWrapper, comparePropsFn([
	'auditFavorites', 'myFavorites', 'projectDescription', 'projectTitle', 'pledgeAmount', 'assignees',
	'gameImage', 'classes', 'isAuthenticated', 'canEditProjectDetails', 'updateProject',
	'pledgers', 'timeLeft', 'projectDeliveries', 'goalAmount', 'projectShareUrl', 'projectUrl',
	'projectAcceptanceStatus', 'canRejectActiveProject', 'canApproveProject', 'canRejectProject',
	'displayModal', 'moduleId', 'games', 'isMobileRes', 'authenticateTwitch',
	'brandProduct', 'sponsor', 'claimSponsoredProject', 'isFeatured', 'isSubmittable',
]))
